module.exports = __webpack_public_path__ + "static/media/print.83b25956.svg";